export const watchLaterActions = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  GET_ALL_WATCH_LATER_VIDEOS: "GET_ALL_WATCH_LATER_VIDEOS",
  ADD_VIDEO_TO_WATCH_LATER: "ADD_VIDEO_TO_WATCH_LATER",
  REMOVE_VIDEO_TO_WATCH_LATER: "REMOVE_VIDEO_TO_WATCH_LATER",
};
